module.exports = __webpack_public_path__ + "static/media/right-direction-img.aa8a8e9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-direction-img.svg
// module id = 908
// module chunks = 0